<ion-header class="remove-margin-from-safe-area ion-no-border">
  <ion-toolbar >
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-toolbar>
          <ion-buttons slot="end">
            <ion-button (click)="onCloseModal()" 
              ><ion-icon color="dark" name="close"></ion-icon
            ></ion-button>
          </ion-buttons>
        </ion-toolbar>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col style="text-align: center;">
          <h3 style="color: #000;
          font-feature-settings: 'clig' off, 'liga' off;
          
          font-size: 28px;
          font-style: normal;
          font-weight: 400;
          line-height: 120%; /* 33.6px */"> {{('keys.data.vehicles.add_vehicle' | translate : {Default:'Add New Vehicle'}) || 'Add New Vehicle'}}</h3>
        </ion-col>
      </ion-row>
    </ion-grid>
    
   
  </ion-toolbar>
</ion-header>

<ion-content>
  <form  [formGroup]="addVehicleForm">
    <ion-grid class="single-col-wider">
      <ion-row>
        <ion-col size="12" class="ion-no-padding">
          <ion-card>
          <ion-item>
            <ion-label position="stacked">{{('keys.data.vehicles.plate' | translate : {Default:'Plate'}) || 'Plate'}}</ion-label>
            <ion-input
            minlength="2"
              type="text"
             
              formControlName="Plate"
            ></ion-input>
          </ion-item>
        </ion-card>
        </ion-col>
        </ion-row>
        <ion-row *ngIf="dataService.settings['vehicles']['enable_vin']=='1'">
          <ion-col size="12" class="ion-no-padding">
            <ion-card>
              <ion-item >
                <ion-label position="stacked">{{('keys.data.vehicles.vin' | translate : {Default:'VIN'}) || 'VIN'}}</ion-label>
                <ion-input
                  type="text"
                  
                  formControlName="vin"
                ></ion-input>
              </ion-item>
            </ion-card>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12" class="ion-no-padding">
            <ion-card>
              <ion-item>
                <ion-label position="stacked"> {{ ('keys.data.common.province_or_state' | translate : {Default:'Province or State'})
                  ||"Province or State"}}</ion-label>
                <ion-select multiple="false" formControlName="ProvID">
                  <ion-select-option
                    *ngFor="let v of vehiclesSRV?.provinces"
                    [value]="v.ProvID"
                    >{{v.ProvName}}</ion-select-option
                  >
                </ion-select>
              </ion-item>
            </ion-card>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12" class="ion-no-padding">
            <ion-card>
              <ion-item>
                <ion-label position="stacked">{{('keys.data.vehicles.plate_type' | translate : {Default:'Plate Type'}) || 'Plate Type'}}</ion-label>
                <ion-select multiple="false" formControlName="PlateTypeID">
                  <ion-select-option
                    *ngFor="let v of vehiclesSRV?.plateTypes"
                    [value]="v.TypeID"
                    >{{v.TypeName}}</ion-select-option
                  >
                </ion-select>
              </ion-item>
            </ion-card>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12" class="ion-no-padding">
            <ion-card>
              <ion-item>
                <ion-label position="stacked">{{('keys.data.vehicles.make' | translate : {Default:'Make'}) || 'Make'}}</ion-label>
                <ion-select multiple="false" formControlName="MakeID">
                  <ion-select-option
                    *ngFor="let v of vehiclesSRV?.makes"
                    [value]="v.MakeID"
                    >{{v.MakeName}}</ion-select-option
                  >
                </ion-select>
              </ion-item>
            </ion-card>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12" class="ion-no-padding">
            <ion-card>
              <ion-item>
                <ion-label position="stacked">{{('keys.data.vehicles.vehicle_type' | translate : {Default:'Vehicle Type'}) || 'Vehicle Type'}}</ion-label>
                <ion-select multiple="false" formControlName="TypeID">
                  <ion-select-option
                    *ngFor="let v of vehiclesSRV?.types"
                    [value]="v.TypeID"
                    >{{v.TypeName}}</ion-select-option
                  >
                </ion-select>
              </ion-item>
            </ion-card>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12" class="ion-no-padding">
            <ion-card>
              <ion-item>
                <ion-label position="stacked">{{('keys.data.vehicles.colour' | translate : {Default:'Colour'}) || 'Colour'}}</ion-label>
                <ion-select multiple="false" formControlName="ColourID">
                  <ion-select-option
                    *ngFor="let v of vehiclesSRV?.colours"
                    [value]="v.ColourID"
                    >{{v.ColourName}}</ion-select-option
                  >
                </ion-select>
              </ion-item>
            </ion-card>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12" class="ion-no-padding">
            <ion-card>
              <ion-item>
                <ion-label position="stacked">{{('keys.data.common.year' | translate : {Default:'Year'}) || 'Year'}}</ion-label>
                <ion-input
                [required]="dataService?.settings?.vehicles?.require_vehicle_year"
                  type="number"
                 max={{nextYear}}
                 maxlength=4
                  formControlName="Year"
                ></ion-input>
              </ion-item>
            </ion-card>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="ion-no-padding" size="12">
            <ion-card>
              <ion-item>
                <ion-label >{{('keys.data.vehicles.electric_vehicle' | translate : {Default:'Electric Vehicle'}) || 'Electric Vehicle'}}</ion-label>
                <ion-checkbox formControlName="electric_vehicle" slot="end"></ion-checkbox>
              </ion-item>
            </ion-card>
          </ion-col>
        </ion-row>
          <ion-row>
            <ion-col>
              <ion-button [disabled]="addVehicleForm.invalid || addVehicleForm.pristine" color="primary" expand="block" (click)="onSaveChanges()">
                {{('keys.data.common.save_changes' | translate : {Default:'Save Changes'}) || 'Save Changes'}}
              </ion-button>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-button fill="clear" expand="block" color="primary" color="primary" (click)="onCloseModal()">{{('keys.data.common.close' | translate : {Default:'Close'}) || 'Close'}}  </ion-button>
            </ion-col>
          </ion-row>
    </ion-grid>
  </form>
</ion-content>

